import styled from "styled-components";

export const SelectWrapper = styled.div`
    margin: 4px;
    display: flex;
    align-items: center;
    > div {
        margin-bottom: 0;
    }
`;

export const ScaleAlert = styled.div`
    display: inline-block;
    margin-left: 14px;
    .i-alert {
        font-size: 17px;
        display: block;
        position: relative;
        left: -4px;
        margin-right: -1px;
        cursor: pointer;
        color: ${p => p.theme.c.info};
    }

    animation: scaleAlert infinite 2s;

    @keyframes scaleAlert {
        0% {
            transform: scale(0.9);
        }
        50% {
            transform: scale(1.24);
        }
        100% {
            transform: scale(0.9);
        }
    }
`;

export const TooltipLabel = styled.div`
    text-align: center;
`;
